import React from 'react';
export const subjectColors = {
  turkce: {
    from: 'from-red-600',
    to: 'to-pink-600'
  },
  matematik: {
    from: 'from-blue-500',
    to: 'to-cyan-500'
  },
  fen: {
    from: 'from-emerald-600',
    to: 'to-teal-600'
  },
  inkılap: {
    from: 'from-amber-600',
    to: 'to-yellow-600'
  },
  ingilizce: {
    from: 'from-purple-500',
    to: 'to-violet-500'
  },
  din: {
    from: 'from-blue-900',
    to: 'to-blue-800'
  }
};
export const getSubjectGradient = (subjectId: string = 'matematik') => {
  return subjectColors[subjectId.toLowerCase() as keyof typeof subjectColors] || {
    from: 'from-purple-600',
    to: 'to-indigo-600'
  };
};
// Ders adlarına göre renk haritası
export const DERS_RENKLERI: Record<string, string> = {
  TÜRKÇE: 'from-red-600 to-pink-600',
  MATEMATİK: 'from-blue-500 to-cyan-500',
  'FEN BİLİMLERİ': 'from-emerald-600 to-teal-600',
  'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK': 'from-amber-600 to-yellow-600',
  İNGİLİZCE: 'from-purple-500 to-violet-500',
  'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ': 'from-blue-900 to-blue-800',
  FİZİK: 'from-indigo-600 to-blue-700',
  KİMYA: 'from-green-600 to-emerald-600',
  BİYOLOJİ: 'from-teal-600 to-green-500',
  TARİH: 'from-amber-700 to-orange-600',
  COĞRAFYA: 'from-lime-600 to-green-600'
};